<template>
  <v-app :style="appStyle">
    <!--     <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-list-item :key="item.text" :to="item.to" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
 -->
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="white"
      elevate-on-scroll
    >
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <v-toolbar-title
        ><router-link style="text-decoration: none; color: inherit;" to="/"
          >Liteword</router-link
        ></v-toolbar-title
      >

      <v-spacer></v-spacer>

      <v-btn
        v-if="loggedIn"
        text
        href="https://forms.gle/FBsYymGsKX44zFqA8"
        target="_blank"
      >
        <span class="ml-2">Give Feedback</span>
      </v-btn>

      <v-menu v-if="loggedIn" bottom left transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click.stop.prevent>
            <v-avatar>
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item href="/accounts/logout/">
            <v-list-item-content>
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-else>
        <v-btn text href="/accounts/login">Log in</v-btn>
        <v-btn
          class="ml-2"
          elevation="0"
          color="primary"
          href="/accounts/signup"
          >Sign up</v-btn
        >
      </div>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-footer
      class="py-7 px-7 text-body-2"
      style="border-top: 1px solid #e7e7e7; color: #545454"
    >
      <span>&copy; {{ new Date().getFullYear() }} Liteword.com</span>
      <v-spacer></v-spacer>
      <span
        ><a
          class="font-weight-medium"
          href="mailto:support@liteword.com"
          style="text-decoration: none; color: inherit;"
          >Contact us</a
        ></span
      >
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",

  methods: {
    ...mapActions(["initAuth"]),
  },

  data: () => ({
    drawer: null,
    items: [
      { icon: "mdi-home", text: "Home", to: "/" },
      { icon: "mdi-content-copy", text: "Your Lists", to: "/lists" },
      // { icon: 'mdi-cog', text: 'Settings' },
    ],
  }),

  computed: {
    ...mapGetters(["loggedIn"]),

    appStyle() {
      return this.$vuetify.theme.dark ? {} : { "background-color": "#f2f2f2" };
    },
  },

  created() {
    this.initAuth();
  },
};
</script>
